import Vue from 'vue';

export function noAbc(event: KeyboardEvent, custom_reg_ex: string | null = null) {
    const regex = custom_reg_ex !== null ? new RegExp(custom_reg_ex) : /^-?\d*[.,]?\d{0,9}$/;
    const key = event.key;

    // Разрешаем служебные клавиши
    if (
        key === 'Backspace' || key === 'Delete' ||
        key === 'ArrowLeft' || key === 'ArrowRight' ||
        key === 'Tab' || key === 'Enter' ||
        (event.ctrlKey || event.metaKey) // Ctrl+C, Ctrl+V и т.д.
    ) return;

    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    // Нормализуем запятую → точка
    const char = key === ',' ? '.' : key;

    const nextValue = input.value.substring(0, start) + char + input.value.substring(end);

    if (!regex.test(nextValue)) {
        event.preventDefault();
    }
}

export function nextInput(event: any, zero_if_empty: boolean = true) {
    event.preventDefault();
    // Isolate the node that we're after
    const currentNode = event.target;
    // find all tab-able elements
    const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
    // Find the current tab index.
    const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
    if (zero_if_empty && !event.target.value) {
        event.target.value = 0;
    }
    // select/focus the following element
    const targetIndex = (currentIndex + 1) % allElements.length;
    if (targetIndex < allElements.length) {
        allElements[targetIndex].select();
    }
}

export function inputFixed(item: any, field: string, value: any, digit: number = 3, is_int: boolean = false, empty_value: number | null = 0) {
    const text = value ? value.toString().replace(/,/g, '.').replace(/\s/g, '') : '';
    const parsed = is_int ? parseInt(text, 10) : parseFloat(text);
    if (Number.isNaN(parsed)) {
        Vue.set(item, field, empty_value);
        return;
    }
    Vue.set(item, field, is_int ? parsed : parseFloat(parsed.toFixed(digit)));
}